import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import { map } from 'rxjs/operators';

export const anonymousGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  return authService.anonymousRouting().pipe(
    map(isAllowed => isAllowed)
  );
};
